function colorGuide() {
  const colorGuideWrapper = document.querySelector('[data-color-guide]');
  const colorGuideContent = colorGuideWrapper.querySelector('[data-color-guide-content]');
  const toggles = colorGuideWrapper.querySelectorAll('[data-color-guide-toggle]');
  const bulkColors = colorGuideWrapper.getAttribute('data-color-guide');

  if (!colorGuideWrapper) { return; }

  if (bulkColors.includes(',')) {
    const colorData = bulkColors.split(/\r?\n/);
    let colorElements = '';

    for (let i = 1; i < colorData.length; i++) {
      const values = colorData[i].split(',');
      colorElements +=
        `<div class="color-guide__color" style="background-color: ${values[1]};" data-color-guide-color="all">
          <p>${values[0]}</p>
        </div>`;
    }

    colorGuideContent.insertAdjacentHTML('beforeend', colorElements);
    colorToggles();
  } else {
    colorToggles();
  }

  function colorToggles() {
    const colors = colorGuideWrapper.querySelectorAll('[data-color-guide-color]');

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const group = toggle.getAttribute('data-color-guide-toggle');

        toggles.forEach((tog) => {
          tog.classList.remove('active');
        });

        colors.forEach((color) => {
          if (color.getAttribute('data-color-guide-color').includes(group)) {
            color.classList.add('active');
          } else {
            color.classList.remove('active');
          }

          if (group === 'all')  {
            color.classList.add('pantone-skinny');
          } else {
            color.classList.remove('pantone-skinny');
          }
        });

        toggle.classList.add('active');
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  colorGuide();
});
